import React from 'react';

import PropTypes from 'prop-types';

import BaseParameters from '../base/components/BaseParameters';
import { createFieldRegistry } from '../base/components/FieldRegistry';

const Parameters = ({ algorithmOptions, control, disabled, setValue }) => {
    const fields = createFieldRegistry({ control, disabled, setValue });

    const fieldsMappingByAlgorithm = {
        bess_api_key: [
            fields.apiKey,
            fields.additionalCoverage,
            fields.annualIncrease,
        ],
        ppa_api_key: [fields.apiKey, fields.annualIncrease],
        ppa_installment: [
            fields.additionalCoverage,
            fields.dealerFee,
            fields.annualIncrease,
        ],
        pto_api_key: [
            fields.apiKey,
            fields.additionalCoverage,
            fields.annualIncrease,
        ],
        pv_bess_api_key: [
            fields.apiKey,
            fields.additionalCoverage,
            fields.annualIncrease,
        ],
        static_payment: [
            fields.additionalCoverage,
            fields.annualIncrease,
            fields.dealerFee,
            fields.interestRate,
            fields.taxOnInterest,
            fields.commissionCredit,
            fields.downPayment,
        ],
        static_payment_tax: [
            fields.additionalCoverage,
            fields.dealerFee,
            fields.interestRate,
            fields.taxOnInterest,
            fields.commissionCredit,
            fields.downPayment,
        ],
    };

    return (
        <BaseParameters
            algorithmOptions={algorithmOptions}
            control={control}
            disabled={disabled}
            fieldsMappingByAlgorithm={fieldsMappingByAlgorithm}
            setValue={setValue}
        />
    );
};

Parameters.propTypes = {
    algorithmOptions: PropTypes.array,
    control: PropTypes.object,
    disabled: PropTypes.bool,
    setValue: PropTypes.func,
};

export default Parameters;
